import React from 'react';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { IApplicationState } from '../../Store';
import { useFormulaire } from '../../lib/formulaireContext/hooks/useFormulaire';
import { SpotSection } from './FormSections/SpotSection';
import { FirstDiffusionSection } from './FormSections/FirstDiffusionSection';
import { WorksSection } from './FormSections/WorksSection';
import { DeclarantSection } from './FormSections/DeclarantSection';
import { FormGroup, FormControlLabel, Checkbox, Grid } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import { FormHead } from './FormSections/FormHead';
import { FormFooter } from './FormSections/Footer/FormFooter';
import { Controller, ControllerRenderProps } from 'react-hook-form';
interface FormulaireProps {
  fgpId: number;
  bucketId: number;
  userGroupId: number;
}

export const FormulaireContent: React.FC<FormulaireProps> = ({
  fgpId,
  bucketId,
  userGroupId
}) => {
  const { form, isLoading, formulaire } = useFormulaire(bucketId, fgpId, userGroupId, 'fr');
  const country = 'fr';
  const i18n = useSelector((state: IApplicationState) => state.i18n.i18n);
  const formulairePDF = useSelector((state: IApplicationState) => state.formulaire.formulairesPDF);

  const [warningMessage, setWarningMessage] = useState<string | null>(null);

  useEffect(() => {
    const formData = form.watch();
    if (!formData?.spot?.spotLink) {
      setWarningMessage(i18n._('Attention! Master filepath is empty'));
    } else {
      setWarningMessage(null);
    }
  }, [form.watch(), country]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div style={{ width: '85%', margin: '0 auto' }}>
      <form encType="multipart/form-data">
        <FormHead formulaire={formulaire} />
        {formulaire.envelope_status === "completed" && formulairePDF && (
          <div>
            <h2>Formulaire signé</h2>
            <iframe src={formulairePDF.fileURL} style={{ width: '100%', height: 'calc(100vh - 100px)', border: 'none' }} title="Formulaire PDF signé" />
          </div>
        )}
        <div style={{ display: formulaire.envelope_status === "completed" && formulairePDF ? 'none' : 'block' }}>
            <Grid container style={{ marginTop: 20, marginBottom: 20 }}>
              <InfoIcon />
              <span style={{ marginLeft: 10 }}>
                {i18n._(
                  'Le dépôt à la Sacem d’un spot publicitaire doit impérativement comprendre toutes les mentions relatives à l’identification des oeuvres musicales utilisées dans le spot.'
                )}
              </span>
            </Grid>

            <SpotSection form={form} />
            <FirstDiffusionSection form={form} />
            <WorksSection form={form} />
            <Grid container>
              <InfoIcon />
              <span style={{ marginLeft: 10 }}>
                {i18n._(
                  'En cas de création d’une nouvelle bande sonore incluant la signature musicale de la marque (ou logo musical de marque), il vous appartient d’obtenir l’accord des ayants droit concernés (votre responsabilité à l’égard de ces ayants droit est engagée).'
                )}
              </span>
            </Grid>
            <DeclarantSection form={form} />
            <Grid container style={{ marginTop: 20, marginBottom: 20 }}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Controller
                      name="should_send_to_sacem"
                      control={form.control}
                      render={(props: ControllerRenderProps) => (
                        <Checkbox
                          checked={props.value ?? false}
                          onChange={(e) => props.onChange(e.target.checked)}
                        />
                      )}
                    />
                  }
                  label="Envoyer automatiquement le document à la Sacem après signature"
                />
              </FormGroup>
            </Grid>
          </div>
        <Grid container style={{ marginTop: 20, marginBottom: 20 }}>
          <FormFooter form={form} />
        </Grid>
        {warningMessage && (
          <Grid container>
            <span>{warningMessage}</span>
          </Grid>
        )}
      </form>
    </div>
  );
};
